<template>
    <div class="feedback-success-pg">
        <div class="container">
            <div class="position">
                <div class="bg-white p-20">
                    <p>Уважаемый {{ appeal.second_name }} {{ appeal.first_name }} {{ appeal.last_name }}!</p>
                    <p>Ваше обращение принято.</p>
                    <p>После его рассмотрения, Вы получите ответ на Ваш электронный адрес, либо свяжутся по телефону.</p>
                    <p>Благодарим за сотрудничество!</p>
                    <div class="btn-group">
                        <router-link
                            tag="button"
                            :to="$i18nRoute({ name: 'home' })"
                            class="btn btn-default white"
                        >{{$t("На главную страницу")}}</router-link>
                        <router-link
                            tag="button"
                            :to="$i18nRoute({ name: 'feedback-add' })"
                            class="btn btn-default blue"
                        >{{$t("Создать обращение еще раз")}}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Appeal from '@/model/appeal'
  import {mapMutations} from 'vuex'

export default {
    data() {
        return {
            appeal: {}
        }
    },
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      $route: 'fetchData'
    },
    created() {
      // загружаем данные, когда представление создано
      // и данные реактивно отслеживаются
      this.fetchData()
      this.scrollToTop()
    },
    methods: {
        ...mapMutations(['setLoading']),
        // подгрузка данных
        fetchData() {
            this.setLoading(true)
            Appeal.getAppeal(this.$route.params.id).then((response) => {
                this.appeal = response.data.appeal
                this.setLoading(false)
            })
        },
        // Прокручивание к началу страницы
        scrollToTop() {
          window.scrollTo(0, 0)
        }
    }
}
</script>
